import { Container, Icon } from 'components/ui'
import { ObjectStrings } from 'interfaces'
import { Typography } from '@mui/material'
import { FactorAssetInfo } from 'types/factor'
import { isDefined } from 'tools/common'
import { getSingletonFactorAssetByType } from 'tools/factorAssets'

type MarketingChangelogProps = {
  styles: ObjectStrings
  hostName?: string
}

const MarketingChangelog = (props: MarketingChangelogProps) => {
  const { styles, hostName } = props
  const marketingLogo: FactorAssetInfo | undefined = getSingletonFactorAssetByType(
    'MAIN_LOGIN_SCREEN_IMAGE',
    hostName || ''
  )

  const appVersion = process.env.REACT_APP_VERSION
  const appYear = new Date().getFullYear()

  const mainLogoSection = isDefined(marketingLogo) ? (
    <div className={styles.marketingIconContainer}>
      <img src={marketingLogo.assetUrl} alt="Marketing Logo" />
    </div>
  ) : (
    <>
      <Icon boxClassName={styles.marketingIconContainer} name="icon_marketing_logo" size={250} />
      <Typography className={styles.marketingContent}>The Best Invoice Factoring Software</Typography>
    </>
  )

  return (
    <Container className={styles.marketingContainer}>
      {mainLogoSection}
      <Typography variant="caption" className={styles.betaVersion}>
        {`© ${appYear}, Version ${appVersion}`}
      </Typography>
    </Container>
  )
}

export default MarketingChangelog
